export const AUTH_SUBMIT_STATE = {
	IDLE: 'idle',
	PENDING: 'pending',
	SUCCESS: 'success',
};

export const AUTH_SUCCESS_DELAY_MS = 500;
export const AUTH_COMPLETE_DELAY_MS = 2000;
